.paper {
  z-index: var(--dds-zindex-tooltip);
}
